import React from "react";
import RadioGroup from "../component/RadioGroup";
import { dcThresholdCalculationInfo } from "../../utils/constants";
import DcThresholdCustomTable from "./DcThresholdCustomTable";

const DemandLimitCalculation = ({
  handleDcthreshold,
  dcthreshold,
  handleDcThresholdCustomMonth,
  dcthresholdCustomMonthErrors,
  generateDefaultData,
}) => {
  const tooltipDataJSON = (limitType) => {
    return (
      <div className="row">
        <div className="col-sm-12 pl-5">
          <div className="row">
            <ul className="col-sm-12" style={{ listStyle: "disc" }}>
              <li> {dcThresholdCalculationInfo.billing}</li>
              {dcthreshold?.valueType === "PERCENTAGE" && (
                <li>{dcThresholdCalculationInfo.percentage}</li>
              )}
            </ul>
            <ul className="col-sm-12 pl-5" style={{ listStyle: "disc" }}>
              {limitType === "DemandLimit1" && (
                <li>
                  Power <span className="bold">Demand Limit 1:</span> applied
                  during Max DC period(s)*.
                </li>
              )}
              {limitType === "DemandLimit2" && (
                <li>
                  Power <span className="bold">Demand Limit 2:</span> applied
                  irrespective of the period.
                </li>
              )}
            </ul>
            <ul className="col-sm-12" style={{ listStyle: "disc" }}>
              <li>{dcThresholdCalculationInfo.dcPeriod}</li>
              <li className="se-life-green se-font-14px-bold">
                {" "}
                {dcThresholdCalculationInfo.applicableNext}
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="col-sm-12">
      <div className="row mb-3">
        <div className="col-sm-12">
          <RadioGroup
            options={[
              {
                value: "FIXED",
                label: "Default",
                description: `"Same value for all the months"`,
              },
              {
                value: "CUSTOM",
                label: "Custom",
                description: `"Custom value for each month"`,
              },
            ]}
            handleDcthreshold={handleDcthreshold}
            dcthreshold={dcthreshold}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="form-group row">
            <label
              htmlFor="valueType"
              className="col-sm-2 col-form-label text-right"
            >
              Type
              <span className="se-mandatory">*</span>
            </label>
            <div className="col-sm-4">
              <select
                className="col-sm-12 col-lg-12 col-md-12 col-xl-12  form-control form-control-md"
                id="demandLimit"
                name="valueType"
                value={dcthreshold?.valueType}
                onChange={handleDcthreshold}
              >
                <option value={"PERCENTAGE"} key={"PERCENTAGE"}>
                  {"Percentage"}
                </option>
                <option value={"VALUE"} key={"VALUE"}>
                  {"Value"}
                </option>
              </select>
              <div
                className={`${false ? "invalid-feedback-custom" : "hidden"}`}
              ></div>
            </div>
          </div>

          {dcthreshold?.type === "FIXED" && (
            <>
              <div className="form-group row ">
                <label
                  htmlFor="demandLimit1"
                  className="col-sm-2 col-form-label text-right"
                >
                  {`Demand Limit 1 (${
                    dcthreshold?.valueType === "VALUE" ? "kW" : "%"
                  })`}
                  <span className="se-mandatory">*</span>
                </label>
                <div className="col-sm-4">
                  <input
                    type="text"
                    autoComplete="none"
                    className="form-control form-control-md"
                    maxLength="5"
                    name="demandLimit1"
                    value={dcthreshold?.fixedValues?.peakPreset}
                    onChange={handleDcthreshold}
                  />
                  <div
                    className={`${
                      !/^\d+$/.test(dcthreshold?.fixedValues?.peakPreset) ||
                      (dcthreshold?.valueType !== "VALUE" &&
                        !/^(100(\.0{1,2})?|(\d{1,2}(\.\d{1,2})?))$/.test(
                          dcthreshold?.fixedValues?.peakPreset
                        )) ||
                      dcthreshold?.fixedValues?.peakPreset === "" ||
                       Number(dcthreshold?.fixedValues?.peakPreset) < 0 ||
                      Number(dcthreshold?.fixedValues?.peakPreset) > 100
                        ? "invalid-feedback-custom"
                        : "hidden"
                    }`}
                  >
                    {dcthreshold?.valueType !== "VALUE"
                      ? "Please enter a valid value between 0 to 100"
                       : dcthreshold?.fixedValues?.peakPreset ==="" || (Number(dcthreshold?.fixedValues?.peakPreset) > 999 ||
                      Number(dcthreshold?.fixedValues?.peakPreset)< 0)?"Please enter a valid value between 0 to 999":""}
                  </div>
                </div>
              </div>

              <div className="form-group row ">
                <label
                  htmlFor="demandLimit2"
                  className="col-sm-2 col-form-label text-right"
                >
                  {`Demand Limit 2 (${
                    dcthreshold?.valueType === "VALUE" ? "kW" : "%"
                  })`}
                  <span className="se-mandatory">*</span>
                </label>
                <div className="col-sm-4">
                  <input
                    type="text"
                    autoComplete="none"
                    className="form-control form-control-md"
                    maxLength="5"
                    name="demandLimit2"
                    value={dcthreshold?.fixedValues?.billingPeriodPreset}
                    onChange={handleDcthreshold}
                  />
                  <div
                    className={`${
                      !(/^\d+$/.test(
                        dcthreshold?.fixedValues?.billingPeriodPreset
                      )) ||
                      (dcthreshold?.valueType !== "VALUE" &&
                        !/^(100(\.0{1,2})?|(\d{1,2}(\.\d{1,2})?))$/.test(
                          dcthreshold?.fixedValues?.peakPreset
                        )) ||
                      (dcthreshold?.valueType === "VALUE" &&
                           dcthreshold?.fixedValues?.billingPeriodPreset > 999 ||
                      dcthreshold?.fixedValues?.billingPeriodPreset < 0
                       ) ||
                      dcthreshold?.fixedValues?.billingPeriodPreset === "" ||
                      Number(dcthreshold?.fixedValues?.billingPeriodPreset) > 100 ||
                     Number(dcthreshold?.fixedValues?.billingPeriodPreset) < 0
                        ? "invalid-feedback-custom"
                        : "hidden"
                    }`}
                  >
                    {dcthreshold?.valueType !== "VALUE"
                      ? "Please enter a valid value between 0 to 100"
                      :dcthreshold?.fixedValues?.billingPeriodPreset === "" || (Number(dcthreshold?.fixedValues?.billingPeriodPreset) > 999 ||
                      Number(dcthreshold?.fixedValues?.billingPeriodPreset) < 0)?"Please enter a valid value between 0 to 999":""}
                  </div>
                </div>
              </div>
            </>
          )}

          {dcthreshold?.type === "CUSTOM" && (
            <DcThresholdCustomTable
              dcthreshold={dcthreshold}
              handleDcThresholdCustomMonth={handleDcThresholdCustomMonth}
              dcthresholdCustomMonthErrors={dcthresholdCustomMonthErrors}
              generateDefaultData={generateDefaultData}
              tooltipDataJSON={tooltipDataJSON}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DemandLimitCalculation;
